import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h2V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.17c1.165.413 2 1.524 2 2.83v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V7c0-1.306.835-2.417 2-2.83zm1 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm9.6 2.2a1 1 0 0 1 .2 1.4L12 12h2a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-1.6-1.2L12 14h-2a1 1 0 0 1-.8-1.6l3-4a1 1 0 0 1 1.4-.2"
    }, null, -1)
  ]))]))
}
export default { render: render }